import styled from 'styled-components';

export const StyledSavedCardRow = styled.div`
  width: 100%;
`;
